import { render, staticRenderFns } from "./invitationModel.vue?vue&type=template&id=b7e34f46&scoped=true&lang=pug&"
import script from "./invitationModel.vue?vue&type=script&lang=js&"
export * from "./invitationModel.vue?vue&type=script&lang=js&"
import style0 from "./invitationModel.vue?vue&type=style&index=0&id=b7e34f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e34f46",
  null
  
)

export default component.exports